import { PORTFOLIO_COLOR, useHistoricDistribution } from "@iliotech/data-wire";
import { Period } from "@iliotech/generated-api";
import { Serie } from "@iliotech/widgets";
import React from "react";
import { HistoricReturnChartProps } from "src/components/__consumerCharts";

export interface IProps {
  portfolioId: string;
  isMonthly: boolean;
  overridePeriod?: Period;
}
export const useHistoricRiskData = ({
  isMonthly,
  portfolioId,
  overridePeriod,
}: IProps) => {
  const { data: historicDistribution } = useHistoricDistribution(
    portfolioId,
    isMonthly ? "Monthly" : "Daily",
    overridePeriod
  );

  const historicData: HistoricReturnChartProps = React.useMemo(() => {
    if (!historicDistribution)
      return { chartData: [], categories: [], zeroIndex: 0 };

    const categories = historicDistribution?.data?.bins?.map(
      (bin) => bin.lowerBound
    );

    const getUpperBound = (lowerBound: number) => {
      const item = historicDistribution?.data?.bins?.find(
        (bin) => bin.lowerBound === lowerBound
      );
      return item?.upperBound;
    };

    const chartData: Serie[] = [
      {
        name: "test",
        values: historicDistribution?.data?.bins?.map((bin) => bin.value),
        color: PORTFOLIO_COLOR,
      },
    ];

    return {
      chartData,
      categories,
      mean: historicDistribution?.data?.mean,
      getUpperBound,
    };
  }, [historicDistribution]);

  return historicData;
};
